export default class SpeciesModel {
    constructor({ title }) {
        this.title = title;
    }
}
